import { render, staticRenderFns } from "./ModalMoverDocumento.vue?vue&type=template&id=01f77ca8&scoped=true&"
import script from "./ModalMoverDocumento.vue?vue&type=script&lang=js&"
export * from "./ModalMoverDocumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f77ca8",
  null
  
)

export default component.exports